/* Outdoors Nordic. Flyttad ur blocks/on-price-row.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */
(function () {
if (window.__onPrbInit) return;
window.__onPrbInit = true;
/* Galleri-placering. Samma vardval som galleriets badges: rutnatets forsta ruta pa
dator, forsta sliden pa mobil - den som faktiskt syns. Den dolda halvan har
bredd 0 och valjs bort, och flytten gors om nar bredden andras eller nar en bild
befordras till toppen. */
function galleryHost() {
var g = document.querySelector('media-gallery');
if (!g) return null;
var cands = [];
var grid = g.querySelector('.media-gallery__grid');
if (grid && grid.firstElementChild) cands.push(grid.firstElementChild);
var slide = g.querySelector('slideshow-slide');
if (slide) cands.push(slide);
var mc = g.querySelector('.product-media-container');
if (mc) cands.push(mc);
for (var i = 0; i < cands.length; i++) {
 if (cands[i].offsetParent !== null && cands[i].getBoundingClientRect().width > 0) return cands[i];
}
return cands[0] || null;
}
function placeStrips() {
var strips = document.querySelectorAll('[data-prb-gallery]');
if (!strips.length) return;
var host = galleryHost();
if (!host) return;
if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
/* Finns galleriets badge-lager ager DET hornet och adopterar remsan in i
  stacken (se on-gallery-badges.adoptStrips). Vi rör inte placeringen da -
  forr placerade bada blocken, med olika fordrojning, och vid varje byte
  mellan mobil och dator vann fel sida sa remsan la sig over Bastsaljare. */
var badgeLayer = document.querySelector('.on-bdg__layer');
for (var i = 0; i < strips.length; i++) {
 if (!badgeLayer) {
   if (strips[i].parentElement !== host) host.appendChild(strips[i]);
   strips[i].classList.remove('on-prb--instack');
 }
 strips[i].classList.add('is-placed');
}
}
/* ETT budskap per sida. Sager bade galleriets BOGO-badge och remsan samma sak
vinner BADGEN: den syns aven pa produktkorten, sa erbjudandet star med samma
ord i hela butiken, medan remsan bara finns pa produktsidan.
- Remsa vars hela innehall ar erbjudandet (galleri-laget, "bara rabatten"):
  hela remsan doljs.
- Remsa pa prisraden: bara meningen "Kop 1 + 1 gratis" tas bort, priset
  "Kop 2 for X" star kvar. Da forsvinner upprepningen utan att nagon
  information gar forlorad.
Allt kommer tillbaka av sig sjalvt om badgen stangs av. */
function dedupeBogo() {
var g = document.querySelector('media-gallery');
var dup = !!(g && g.querySelector('.on-bdg__badge--bogo'));
var strips = document.querySelectorAll('.on-prb');
for (var i = 0; i < strips.length; i++) {
 if (strips[i].hasAttribute('data-prb-bogo')) { strips[i].hidden = dup; continue; }
 var ph = strips[i].querySelectorAll('[data-prb-bogo-phrase]');
 for (var j = 0; j < ph.length; j++) ph[j].hidden = dup;
}
}
var pt;
function placeSoon() { clearTimeout(pt); pt = setTimeout(function () { placeStrips(); dedupeBogo(); }, 80); }
/* Direkt, inte pa DOMContentLoaded: scriptet ligger EFTER galleriet i dokumentet,
sa varden finns redan har. Flytten sker da innan sidan ritas upp forsta gangen
och besokaren ser aldrig remsan pa fel plats. */
placeStrips();
dedupeBogo();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeSoon);
else placeSoon();
/* Badgen skrivs av galleriblocket, som kan kora efter oss. Tva sena pass gor att
remsan aldrig blir kvar bredvid en badge som dok upp en tiondel senare. */
setTimeout(dedupeBogo, 400);
setTimeout(dedupeBogo, 1500);
/* Failsafe: hittades ingen bildruta alls (annan mall, galleriet dolt) visas remsan
dar den star i stallet for att bli osynlig. */
setTimeout(function () {
var s = document.querySelectorAll('[data-prb-gallery]:not(.is-placed)');
for (var i = 0; i < s.length; i++) s[i].classList.add('is-placed');
}, 2500);
window.addEventListener('resize', placeSoon);
document.addEventListener('variant:update', placeSoon);
document.addEventListener('shopify:section:load', placeSoon);
document.addEventListener('on:gallery:reorder', placeSoon);
[400, 1500].forEach(function (ms) { setTimeout(placeStrips, ms); });
// Öppna/stäng dropdownen. Delegerat på document → funkar även för sektioner som
// renderas om (variantbyte/editor) utan att lyssnare behöver kopplas om.
document.addEventListener('click', function (e) {
var btn = e.target.closest ? e.target.closest('[data-prb-toggle]') : null;
if (btn) {
 var wrap = btn.closest('.on-prb');
 var drop = wrap ? wrap.querySelector('[data-prb-drop]') : null;
 if (!drop) return;
 var open = drop.hasAttribute('hidden');
 // stäng alla andra först
 document.querySelectorAll('[data-prb-drop]').forEach(function (d) {
   if (d !== drop) { d.setAttribute('hidden', ''); var b = d.parentNode.querySelector('[data-prb-toggle]'); if (b) b.setAttribute('aria-expanded', 'false'); }
 });
 if (open) { drop.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
 else { drop.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
 e.preventDefault();
 return;
}
// klick utanför → stäng
if (e.target.closest && e.target.closest('[data-prb-drop]')) return;
document.querySelectorAll('[data-prb-drop]:not([hidden])').forEach(function (d) {
 d.setAttribute('hidden', '');
 var b = d.parentNode.querySelector('[data-prb-toggle]'); if (b) b.setAttribute('aria-expanded', 'false');
});
});
document.addEventListener('keydown', function (e) {
if (e.key !== 'Escape') return;
document.querySelectorAll('[data-prb-drop]:not([hidden])').forEach(function (d) {
 d.setAttribute('hidden', '');
 var b = d.parentNode.querySelector('[data-prb-toggle]'); if (b) b.setAttribute('aria-expanded', 'false');
});
});
  })();

